<ada-card
	#TrackingPropertiesCard
	id="TrackingPropertiesCard"
	width="100%"
	[collapseEnabled]="true"
	[verticalSpacing]="'Small'"
>
	<ada-text
		content="Tracking Properties"
		data-container-selector="ada-card-header"
		id="TrackingPropertiesCardHeader"
	/>
	<ada-container
		data-container-selector="ada-card-body"
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[colCount]="4"
		[padding]="defaultCardPadding"
	>
		<!-- Method -->
		<ng-container *ngIf="'Method' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				content="Method"
				[inheriting]="currentPropertyObject?.Method | inheritPipe: undefined"
				[isDisabled]="isDisabled"
				[isRequired]="'Method' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[renderHTML]="true"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('Method')"
			/>
			<ada-container
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-radio-button
					#MethodInput
					id="MethodInput"
					[buttons]="methodOptions"
					[isDisabled]="isDisabled"
					[value]="currentPropertyObject?.Method"
					(valueChange)="setObjectPropertyValue('Method', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- WebScrapeURL -->
		<ng-container *ngIf="'WebScrapeURL' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				content="Web Scrape URL"
				[inheriting]="currentPropertyObject?.WebScrapeURL | inheritPipe: undefined"
				[isDisabled]="isDisabled"
				[isRequired]="'WebScrapeURL' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[renderHTML]="true"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('WebScrapeURL')"
			/>
			<ada-container
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#WebScrapeURLInput
					id="WebScrapeURLInput"
					[debounce]="100"
					[isDisabled]="isDisabled"
					[maxCharacterLimit]="8000"
					[placeholder]="'Web Scrape URL'"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[showAsFullWidth]="true"
					[value]="currentPropertyObject?.WebScrapeURL"
					(valueChange)="setObjectPropertyValue('WebScrapeURL', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- WebScrapeDescription -->
		<ng-container *ngIf="'WebScrapeDescription' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				content="Web Scrape Description"
				[inheriting]="currentPropertyObject?.WebScrapeDescription | inheritPipe: undefined"
				[isDisabled]="isDisabled"
				[isRequired]="'WebScrapeDescription' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('WebScrapeDescription')"
			/>
			<ada-container
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#WebScrapeDescriptionInput
					id="WebScrapeDescriptionInput"
					[debounce]="100"
					[isDisabled]="isDisabled"
					[maxCharacterLimit]="8000"
					[placeholder]="'Web Scrape Description'"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[showAsFullWidth]="true"
					[value]="currentPropertyObject?.WebScrapeDescription"
					(valueChange)="setObjectPropertyValue('WebScrapeDescription', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- WebScrapeInterval -->
		<ng-container *ngIf="'WebScrapeInterval' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				content="Web Scrape Interval"
				[inheriting]="currentPropertyObject?.WebScrapeInterval | inheritPipe: undefined"
				[isDisabled]="isDisabled"
				[isRequired]="'WebScrapeInterval' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[renderHTML]="true"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('WebScrapeInterval')"
			/>
			<ada-container
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-time-scale
					#WebScrapeIntervalScale
					id="WebScrapeIntervalScale"
					[isDisabled]="isDisabled"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[scaleConfiguration]="webScrapeIntervalConfig"
					[value]="currentPropertyObject?.WebScrapeInterval"
					(valueChange)="setObjectPropertyValue('WebScrapeInterval', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- WebScrapeScanDate -->
		<ng-container *ngIf="'WebScrapeScanDate' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				content="Web Scrape Scan Date"
				[inheriting]="currentPropertyObject?.WebScrapeScanDate | inheritPipe: undefined"
				[isDisabled]="isDisabled"
				[isRequired]="'WebScrapeScanDate' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[renderHTML]="true"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('WebScrapeScanDate')"
			/>
			<ada-container
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#WebScrapeScanDateInput
					id="WebScrapeScanDateInput"
					type="date"
					[debounce]="100"
					[isDisabled]="isDisabled"
					[outputDateAsInteger]="true"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[showAsFullWidth]="true"
					[value]="currentPropertyObject?.WebScrapeScanDate"
					(valueChange)="setObjectPropertyValue('WebScrapeScanDate', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- WebScrapeIdentificationAttributes -->
		<ng-container *ngIf="'WebScrapeIdentificationAttributes' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				content="Web Scrape Identification Attributes"
				[inheriting]="currentPropertyObject?.WebScrapeIdentificationAttributes | inheritPipe: undefined"
				[isDisabled]="isDisabled"
				[isRequired]="'WebScrapeIdentificationAttributes' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[renderHTML]="true"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('WebScrapeIdentificationAttributes')"
			/>
			<ada-container
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#WebScrapeIdentificationAttributesInput
					id="WebScrapeIdentificationAttributesInput"
					[debounce]="100"
					[isDisabled]="isDisabled"
					[maxCharacterLimit]="256000"
					[placeholder]="'Web Scrape Identification Attributes'"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[showAsFullWidth]="true"
					[value]="currentPropertyObject?.WebScrapeIdentificationAttributes"
					(valueChange)="setObjectPropertyValue('WebScrapeIdentificationAttributes', $event)"
				/>
			</ada-container>
		</ng-container>
		<!-- WebScrapeMonitoringAttributes -->
		<ng-container *ngIf="'WebScrapeMonitoringAttributes' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				content="Web Scrape Monitoring Attributes"
				[inheriting]="currentPropertyObject?.WebScrapeMonitoringAttributes | inheritPipe: undefined"
				[isDisabled]="isDisabled"
				[isRequired]="'WebScrapeMonitoringAttributes' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[renderHTML]="true"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('WebScrapeMonitoringAttributes')"
			/>
			<ada-container
				[colCount]="2"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-input
					#WebScrapeMonitoringAttributesInput
					id="WebScrapeMonitoringAttributesInput"
					[debounce]="100"
					[isDisabled]="isDisabled"
					[maxCharacterLimit]="256000"
					[placeholder]="'Web Scrape Monitoring Attributes'"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[showAsFullWidth]="true"
					[value]="currentPropertyObject?.WebScrapeMonitoringAttributes"
					(valueChange)="setObjectPropertyValue('WebScrapeMonitoringAttributes', $event)"
				/>
			</ada-container>
		</ng-container>
	</ada-container>
</ada-card>
